module.exports = __webpack_public_path__ + "img/logo_neu.7c37ae12.png";